import { ButtonTypes } from '../enums/button-types.enum';
import { ButtonType } from '../interfaces/button-type.interface';

export const BUTTON_TYPES: ButtonType[] = [
  {
    value: ButtonTypes.None,
    title: 'Not Assigned',
    parameter: false,
  },

  {
    value: ButtonTypes.Private,
    title: 'Private line',
    parameter: false,
  },
  {
    value: ButtonTypes.Extension,
    title: 'Extension BLF',
    parameter: true,
  },
  {
    value: ButtonTypes.Park,
    title: 'Park Orbit',
    parameter: true,
  },
  {
    value: ButtonTypes.Login,
    title: 'Agent login/logout',
    parameter: true,
  },
  {
    value: ButtonTypes.Flag,
    title: 'Service Flag',
    parameter: true,
  },
  {
    value: ButtonTypes.Speed,
    title: 'Speed Dial',
    parameter: true,
  },

  //last 2 not sure
  {
    value: ButtonTypes.HuntGroup,
    title: 'Hunt group',
    parameter: true,
  },
  {
    value: ButtonTypes.AgentGroup,
    title: 'Agent group',
    parameter: true,
  },

  {
    value: ButtonTypes.Attendant,
    title: 'Auto Attendant',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Hunt,
    title: 'Ring Group',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Queue,
    title: 'Call Queue',
    parameter: true,
    disabled: true,
  },

  {
    value: ButtonTypes.Conference,
    title: 'Conference',
    parameter: true,
    disabled: true,
  },

  {
    value: ButtonTypes.IvrNode,
    title: 'IVR Node',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.CoLine,
    title: 'CO-Line',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Page,
    title: 'Paging',
    parameter: true,
    disabled: true,
  },

  {
    value: ButtonTypes.Intercom,
    title: 'Intercom',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Vm,
    title: 'Voicemail',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Dnd,
    title: 'Do not disturb (DND)',
    parameter: false,
    disabled: true,
  },

  {
    value: ButtonTypes.Redirect,
    title: 'Redirect',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Group,
    title: 'Pickup group',
    parameter: false,
    disabled: true,
  },
  {
    value: ButtonTypes.Cell,
    title: 'Cell Phone',
    parameter: false,
    disabled: true,
  },

  {
    value: ButtonTypes.Url,
    title: 'URL',
    parameter: true,
    disabled: true,
  },

  {
    value: ButtonTypes.Record,
    title: 'Record',
    parameter: false,
    disabled: true,
  },
  {
    value: ButtonTypes.Prefix,
    title: 'Prefix',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Dtmf,
    title: 'DTMF',
    parameter: true,
    disabled: true,
  },
  {
    value: ButtonTypes.Yealink,
    title: 'Yealink',
    parameter: true,
    disabled: true,
  },

  //
  {
    value: ButtonTypes.Local,
    title: 'Configure On Phone',
    parameter: false,
  },
];
